import { styled } from "../../../../../../styles";

export const NebulizerChartDataContainer = styled("div", {
  width: "100%",
  height: "100%",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  variants: {
    isEmpty: {
      true: {
        opacity: 0.36,
      },
    },
  },
});

export const GraphContainer = styled("div", {
  width: "100%",
  height: "67%",
});

export const GraphLegend = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",

  marginBottom: "2px",
});
